import React, { useState, useEffect } from "react";
import logoFacomLong from "./../../images/LOGOFACOMLONG.png";
import "./Header.css";

const Header = ({ config }) => {
  return (
    <div className="header">
      <div className="logo">
        <img src={config ? config.logo : null} />
      </div>
      <div
        className="title"
        style={{ color: config ? config.textColor : "#000" }}
      >
        <div className="headerTitle">Grattez votre TICKET D'OR</div>
        <div className="underTitle">
          et découvrez immédiatement si vous avez gagné !
        </div>
      </div>
    </div>
  );
};

export default Header;
